import { AxiosRequestConfig } from 'axios';

import { HttpClient } from '@httpClient/index';
import Methods from './methods';
import ActionNames from './actionNames';

class CerberService extends HttpClient<ActionNames> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public constructor(request: any, options?: AxiosRequestConfig) {
    super(request, options);

    this.init();
  }

  private init = (): void => {
    this.requests[ActionNames.CAPTCHA_GET] = this.request({
      method: Methods.CAPTCHA_GET,
    });

    this.requests[ActionNames.CAPTCHA_VERIFY] = this.request({
      method: Methods.CAPTCHA_VERIFY,
    });
  };
}

export default CerberService;
